import React from "react";
import RadioInput from "./RadioInput";

const DefaultSearchRate = ({ rate, onChangeRate }) => {
  return (
    <>
      <div className="search-params">
        <div className="pr flex search-param f-wrap v-center">
          <h4 className="m-0 head-text">Rate:</h4>
          <div className="radio-btn-groups rate-radio" onChange={onChangeRate}>
            <RadioInput
              id="daily"
              inputName="radio-group-rate"
              label="Nightly"
              radioType={rate}
            />
            <RadioInput
              id="monthly"
              inputName="radio-group-rate"
              label="Monthly"
              radioType={rate}
            />
          </div>
        </div>
      </div>
      <div className="deafult-search-footer">
        ©2023 Dwellworks Living Confidential & Proprietary
      </div>
    </>
  );
};

export default DefaultSearchRate;
